"use strict";

exports.__esModule = true;
exports.AboveTheFoldOnlyServerRender = undefined;

var _aboveTheFoldOnlyServerRender = require("./components/above-the-fold-only-server-render");

var _aboveTheFoldOnlyServerRender2 = _interopRequireDefault(_aboveTheFoldOnlyServerRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _aboveTheFoldOnlyServerRender2.default;
exports.AboveTheFoldOnlyServerRender = _aboveTheFoldOnlyServerRender2.default;


//////////////////
// WEBPACK FOOTER
// ./~/above-the-fold-only-server-render/lib/index.js
// module id = 376
// module chunks = 1